'use client'
import { Button } from '@/components/Button'
import { Heading } from '@/components/Heading'
import { Text } from '@/components/Text'
import { useTranslation } from 'react-i18next'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const { t } = useTranslation()

    return (
        <div className="text-center pb-20 flex flex-col gap-4">
            <Heading
                tag="h3"
                className="text-center mb-6"
                text={t('eshop.usersettings.error.title')}
            />
            <Text
                className="text-lg"
                text={t('eshop.usersettings.error.description')}
            />
            <Button type="wide" color="link" url="/eshop">
                {t('eshop.notFound.button')}
            </Button>
        </div>
    )
}
